const PAGES = Object.freeze({
	SINGLE_PAGE: "DesignSinglePageRecord",
	SINGLE_PROJECT: "DesignSingleProjectRecord",
	SINGLE_HOW_WE_WORK_PAGE: "DigitalSingleHowWeWorkPageRecord",
	SINGLE_HOW_WE_WORK_PAGE_NEW: "CommonHowWeWorkPageRecord",
	ALL_PROJECTS_PAGE: "DesignAllProjectsPageRecord",
})

const TYPES = Object.freeze({
	PAGES,
})

export default TYPES
